import React, { FC, ReactNode, useState, useCallback, useEffect } from 'react';
import { GoogleMap } from '@react-google-maps/api';

import { useMap } from '../../lib/hooks/map';
import { useSearchQuery } from '../../lib/hooks/search-query';
import { checkMarkerContains } from '../../lib/utils/map';
import { Spots } from '../Spots';


type Props = {
    spots: Spots | null,
    center: {
        lat: number;
        lng: number;
    } | null;
    zoom?: number;
    floatingActionButton?: ReactNode,
    snackBar?: ReactNode;
    styles?: {
        [key: string]: any;
    }[],
    onLoad?(map: GoogleMap): void;
    onIdle?(map: GoogleMap): void;
    onBoundsChanged?(map: GoogleMap): void;
};


export const Map: FC<Props> = ({
    spots,
    center,
    zoom,
    styles,
    floatingActionButton,
    snackBar,
    onLoad,
    onBoundsChanged,
    onIdle,
}) => {
    const [isLimit, setIsLimit] = useState(false);
    const { map, setMap } = useMap();
    const { query } = useSearchQuery();

    const onUnmount = useCallback(function callback() {
        setMap(null);
    }, []);

    useEffect(() => {
        if (!(spots && spots.length > 0 && map)) return;
        const spotsInMap = spots.filter((spot) => {
            return checkMarkerContains(
                { lat: spot.lat, lng: spot.lng },
                map,
            );
        });
        spotsInMap.length >= 50 ? setIsLimit(true) : setIsLimit(false);
    }, [spots]);

    return (
        <div className="wrapper">
            {center && <GoogleMap
                mapContainerClassName="map-container"
                center={center}
                zoom={zoom ?? 15}
                onLoad={(map) => {
                    setMap(map);
                    if (onLoad) onLoad(map);
                }}
                clickableIcons={false}
                onUnmount={onUnmount}
                onBoundsChanged={() => {
                    if (map && onBoundsChanged) {
                        onBoundsChanged(map);
                    };
                }}
                onIdle={() => {
                    if (map && onIdle) {
                        onIdle(map);
                    };
                }}
                options={{
                    gestureHandling: 'greedy',
                    zoomControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    fullscreenControl: false,
                    disableDefaultUI: true,
                    styles: styles,
                }}
            >
                {(spots && spots.length > 0) && (
                    <Spots data={spots} />
                )}
                <div className="tooltip limit-tooltip">
                    表示数の上限（50件）に達しています。条件を絞って再検索してください。
                </div>
                <div className="tooltip noresult-tooltip">
                    {`「${Object.values(query).join(' ')}」に一致する情報は見つかりませんでした。`}
                </div>
                {snackBar}
                {floatingActionButton}
            </GoogleMap>}
            {/*
            <div className="sp-pfofile-header">
                <div className="profile-menu">
                    <a href="/members">
                        <div className="profile-menu-text">
                            <img src="/img/search.png" />
                            <p>プロフィール検索</p>
                        </div>
                    </a>
                </div>
                <div className="profile-menuing">
                    <a href="/map">
                        <div className="profile-menu-text">
                            <img src="/img/map.png" />
                            <p>マップでお店検索</p>
                        </div>
                    </a>
                </div>*/}
            {/* <div className="profile-menu">
                    <a href="/nomitai">
                        <div className="profile-menu-text">
                            <img src="/img/nomitai.png" />
                            <p>呑みたい人</p>
                        </div>
                    </a>
                </div> */}
            {/*</div>*/}

            <style jsx>{`
                .wrappar {
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    position: absolute;
                }
                :global(.map-container) {
                    width: 100%;
                    height: calc(${window.innerHeight}px - 43px - 115px - 38px);
                }
                .tooltip {
                    border: solid 2px #f7f7f7;
                    padding: 8px 14px 8px 14px;
                    position: absolute;
                    top: 5px;
                    left: 30px;
                    background: #fff;
                    box-shadow: 0 0 8px gray;
                    font-size: 14px;
                }
                .limit-tooltip {
                    display: ${isLimit ? "box" : "none"};
                }
                .noresult-tooltip {
                    display: ${spots && spots.length === 0 ? "box" : "none"};
                }
                @media screen and (max-width: 540px) {
                    :global(.map-container) {
                        height: calc(${window.innerHeight}px - 45px - 105px - 34px);
                    }
                    .tooltip {
                        width: 100%;
                        top: 0;
                        left: 0;
                        font-size: 10px;
                    }
                }
                .sp-pfofile-header {
                    display: none;
                }
                .space{
                    height:0px;
                    display: none;
                }
                @media (max-width: 768px) {
                    .sp-pfofile-header {
                        display: flex;
                        width: 100%;
                        position: fixed;
                        bottom: 0;
                        z-index: 9999;

                    }
                    .space{
                        height:80px;
                        display: block;
                    }

                    .profile-menu,
                    .profile-menuing {
                        height: 80px;
                        width: 50%;
                        border-left: 1px solid white;
                        border-right: 1px solid white;
                    }

                    .profile-menu {
                        background-color: #D6D6D6;
                    }
                    .profile-menu a{
                        text-decoration: none;
                    }
                    .profile-menuing a{
                        text-decoration: none;
                    }
                    .profile-menuing {
                        background-color: #F39F65;
                    }

                    .profile-menu-text {
                        display: block;
                        text-align: center;
                    }

                    .profile-menu-text img {
                        width: 2.5rem;
                        padding-top: 10px;
                    }
                    .profile-menu-text p {
                        margin: 0;
                        font-size: 3.3vw;
                        color: #333;
                    }
                }
                .footer-navi {
                    z-index: 7;
                }
                .footer-navi .pcWidth-l > div {
                    display: flex;
                    flex-wrap: wrap;
                    width: 95%;
                    margin: 0 auto;
                }
                .dashboard-content {
                    color: black;
                }
                :global(.map-container > button) {
                    z-index: 8;
                }
            `}</style>
            <div className="footer-navi">
                <section>
                    <div className="sec-dashboard bg1">
                        <div className="pcWidth-l spWidth-max">
                            <div>
                                <div className="topcard-wrap dashboard-wrap">
                                    <a href="/nishino">
                                        <div className="topcard dashboard-layout">
                                            <div className="dashboard-image">
                                                <img className="dashboard-image-size" src="/img/home.png" />
                                            </div>
                                            <div className="dashboard-content">
                                                ホーム
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="topcard-wrap dashboard-wrap">
                                    <a href="/present_projects/">
                                        <div className="topcard dashboard-layout">
                                            <div className="dashboard-image">
                                                <img className="dashboard-image-size" src="/img/present.png" />
                                            </div>
                                            <div className="dashboard-content">
                                                プレゼント
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="topcard-wrap dashboard-wrap">
                                    <a href="/coupon_list/">
                                        <div className="topcard dashboard-layout">
                                            <div className="dashboard-image">
                                                <img className="dashboard-image-size" src="/img/coupon.png" />
                                            </div>
                                            <div className="dashboard-content">
                                                クーポン
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="topcard-wrap dashboard-wrap">
                                    <a href="/map">
                                        <div className="topcard dashboard-layout">
                                            <div className="dashboard-image">
                                                <img className="dashboard-image-size" src="/img/map2.png" />
                                            </div>
                                            <div className="dashboard-content">
                                                <span>チムニー</span><br />マップ
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};
